export function announce(message: string) {
  if (typeof window === 'undefined' || !message.trim()) return;
  window.dispatchEvent(new CustomEvent<string>('app:announce', { detail: message.trim() }));
}
